module.exports = __webpack_public_path__ + "static/img/wap_signin_logo_qxcid.4516c58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys/login/wap_signin_logo_qxcid.png
// module id = IADk
// module chunks = 1